module.exports = __webpack_public_path__ + "static/media/element-01_kovanlashki.58f624d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/element-01_kovanlashki.png
// module id = 196
// module chunks = 0